import React from "react";
import { Bus, CheckCircle2 } from "lucide-react";
import reservationsImg from "../assets/img/reservations.png";
import orangeLogo from "../assets/img/orange-logo.png";
import { ORANGE_CASE } from "../../data/content";
import { Reveal } from "../ui";

const CaseStudy = () => (
  <section id="case-study" className="section pt-0">
    <div className="container">
      <Reveal className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-gradient-to-br from-brand-700/30 via-ink-900 to-ink-950">
        <div className="absolute -right-24 -top-24 h-80 w-80 rounded-full bg-brand-600/30 blur-[100px]" />
        <div className="relative grid gap-10 p-8 sm:p-12 lg:grid-cols-2 lg:items-center lg:p-16">
          <div>
            <div className="flex items-center gap-4">
              <img src={orangeLogo} alt="Orange" width="48" height="48" className="h-12 w-12 rounded-lg" />
              <span className="eyebrow">
                <Bus className="h-3.5 w-3.5 text-brand-400" /> Case study
              </span>
            </div>
            <h2 className="mt-6 font-display text-3xl font-semibold tracking-tight text-white sm:text-4xl">
              Employee bus reservations for Orange, powered by KNTO Pass.
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-ink-300">
              A complete booking and boarding system: a mobile app for employees, a QR reader app for drivers, and a
              cloud dashboard for operations, all running on the KNTO Pass platform.
            </p>
            <ul className="mt-8 space-y-3">
              {ORANGE_CASE.features.map((f) => (
                <li key={f} className="flex items-start gap-3 text-ink-200">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-brand-500" />
                  {f}
                </li>
              ))}
            </ul>
          </div>

          <div className="relative">
            <div className="rounded-3xl border border-white/10 bg-white/5 p-2">
              <img
                src={reservationsImg}
                alt="Bus reservation dashboard and mobile booking apps"
                loading="lazy"
                width="1786"
                height="1261"
                className="w-full rounded-2xl"
              />
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CaseStudy;
